import { otto } from "@gr-exports/head/nexus";
import type { OnexData } from ".";

const { assignments } = otto.onex;

const thisOrData = (data: unknown): OnexData | undefined =>
  !!data && typeof data === "object" && $brand in data
    ? (data[$brand] as OnexData)
    : assignments.get();

const $brand = Symbol("customAssignments");

/**
 *
 *
 *
 */
export type OnexThisObject = { [$brand]: OnexData };

/**
 *
 *
 *
 *
 */
export function customAssignments(data: OnexData): OnexThisObject {
  return { [$brand]: data };
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function isOnexVariant(
  this: unknown | void | OnexThisObject,
  onexId: string,
  groupId: string,
): boolean {
  const data = thisOrData(this);
  if (!data) return false;

  const group = data?.[onexId];
  return !!group && group === groupId;
}

/*                                                */
export const isOnexGroup = isOnexVariant; /*                     */

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function mapOnexVariant<OnexMap extends Record<string, unknown>, D = undefined>(
  this: unknown | void | OnexThisObject,
  onexId: string,
  groupMap: OnexMap,
  ...a: undefined extends D ? [] : [defaultValue: D]
): OnexMap[keyof OnexMap] | D {
  const data = thisOrData(this);
  if (!data) return a[0] as D;

  const group = data[onexId];
  if (!group || groupMap[group] === undefined) return a[0] as D;
  return groupMap[group] as OnexMap[keyof OnexMap];
}

/*                                                 */
export const mapOnexGroup = mapOnexVariant; /*                     */

/**
 *
 */
export interface WithOnex {
  /**
 *
 *
 *
 */
  isVariant: (groupId: string) => boolean;

  /**
 *
 *
 *
 *
 */
  mapVariant: <OnexMap extends Record<string, unknown>, D = undefined>(
    groupMap: OnexMap,
    ...a: undefined extends D ? [] : [defaultValue: D]
  ) => OnexMap[keyof OnexMap] | D;

  /*                                            */
  isGroup: (groupId: string) => boolean;

  /*                                             */
  mapGroup: <OnexMap extends Record<string, unknown>, D = undefined>(
    groupMap: OnexMap,
    ...a: undefined extends D ? [] : [defaultValue: D]
  ) => OnexMap[keyof OnexMap] | D;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function withOnex(this: unknown | void | OnexThisObject, onexId: string): WithOnex {
  const isVariant: WithOnex["isVariant"] = (groupId) => isOnexVariant.call(this, onexId, groupId);
  const mapVariant: WithOnex["mapVariant"] = (groupMap, ...a) =>
    mapOnexVariant.apply(this, [onexId, groupMap, ...a] as never) as never;

  return {
    isGroup: isVariant,
    mapGroup: mapVariant,
    isVariant,
    mapVariant,
  };
}
